import {FC} from "react";
import {CommonOrgTabComponent, EmbeddedComponentLoader} from "./index";

export interface CommonOrgComponentProps {
  component: CommonOrgTabComponent;
  commonOrgId: string;
}

export const CommonOrgComponentLoader: FC<CommonOrgComponentProps> = ({
  component,
  commonOrgId
}) => {
  return (
    <EmbeddedComponentLoader
      component={component}
      attributes={{
        "common-org-id": commonOrgId
      }}
    />
  );
};
